export const APP_EVENTS = {
  SCROLL_LAYOUT_EDITOR: 'SCROLL_LAYOUT_EDITOR'
}
